import React from 'react';
import { Label } from '@progress/kendo-react-labels';
import Select from 'shared/inputs/BaseSelect';
import Button from 'shared/buttons';

const SortSelect = ({
  sortByList = [], onSortChange, sort, defaultSort,
}) => {
  const [{ field: defaultField }] = defaultSort;
  const [sortData] = sort;
  const { dir, field } = sortData;

  const onSortFieldSelect = ({ value }) => {
    onSortChange({
      sort: [
        {
          ...sortData,
          field: value ?? defaultField,
          sortBy: value ?? defaultField,
        },
      ],
    });
  };

  const toggleDir = () => {
    onSortChange({
      sort: [
        {
          ...sortData,
          dir: dir === 'asc' ? 'desc' : 'asc',
        },
      ],
    });
  };

  return (
    <div className='toolbar-sort-select'>
      <Label>Sort By</Label>
      <div className='sort-fields'>
        <Button icon={dir === 'asc' ? 'sort-asc' : 'sort-desc'} onClick={toggleDir} />
        <Select
          data={sortByList}
          onChange={onSortFieldSelect}
          textField='title'
          dataItemKey='field'
          value={field}
          keyOnly
        />
      </div>
    </div>
  );
};

export default SortSelect;
